import MuiMenu from "@mui/material/Menu";

export default function Menu(props) {
  return <MuiMenu {...props} />;
}
